<template>
	<div class="category-animation-1-bg" :class="{'final':isFinished}">
		<img src="@/assets/animations/1/sun.png" class="sun">
		<img src="@/assets/animations/1/star.png" class="star">
	</div>
</template>

<script>
    export default {
        name: "category-animation-1-bg",
        components: {},
        data: () => {
            return {
                isFinished: false,
            }
        },
		methods: {
		},
        mounted() {
            setTimeout(() => this.isFinished = true, 2000);
        }
    }
</script>

<style lang="scss">
	.category-animation-1-bg {
		display: none;
		@include up($md) {
			//height: auto;
			//margin-top: 0;
			position: absolute;

			width: 0;
			//max-width: $lg;
			height: 480px;

			left: 50%;
			top: 0;
			transform: translate(-50%) scale(1);
		}

		img, div {
			position: absolute;
			opacity: 0;

			&.sun {
				z-index: 0;
				animation: animSun 1000ms forwards;
				animation-delay: 200ms;
				transform-origin: 0 400px;
				top: -5%;
				left: 80px;
			}

			&.star {
				z-index: 2;
				animation: animStar1 1000ms forwards;
				animation-delay: 1000ms;
				transform: scale(0);
				top: 0;
				left: 185px;
			}
		}

		&.final {
			img {
				&.star {
					opacity: 1;
					animation: animStar2 500ms infinite alternate;
				}
			}
		}

		@keyframes animSun {
			from {
				transform: rotate(45deg);
			}
			to {
				opacity: 1;
				transform: rotate(0);
			}
		}

		@keyframes animStar1 {
			from {
				opacity: 1;
				transform: scale(0);
			}
			50% {
				opacity: 1;
				transform: scale(1.3);
			}
			to {
				opacity: 1;
				transform: scale(1);
			}
		}

		@keyframes animStar2 {
			from {
				transform: scale(1);
			}
			to {
				transform: scale(.85);
			}
		}
	}

</style>